<template>
  <div class="edit-studio-container">
    <div v-for="block in Object.keys(blocks)">
      <component :is="blocks[block]" :fit20="fit20" v-if="fit20.blockNameToEdit == block" :saveBlock="saveBlock"
        :cancelEditing="cancelEditing"></component>
    </div>
    <br>
  </div>
</template>

<script>
// import isEqual from 'lodash/isEqual';
import CompanyForm from './CompanyForm.vue';
import FoForm from './FoForm.vue';
import Footer from './Footer.vue';
import FosForm from './FosForm.vue'
import KmtForm from './KmtForm.vue'
import KmtStudio from './KmtStudio.vue'
import LastNews from './LastNews.vue'
import LocatorWithoutMap from './LocatorWithoutMap.vue'
import LocatorWithMap from './LocatorWithMap.vue'
import MemberShip from './MemberShip.vue'
import Menu from './Menu.vue'
import NewsLetter from './NewsLetter.vue'
import News from './News.vue'
import Search from './Search.vue'
import StartupPhase from './StartupPhase.vue'
import StudioContact from './StudioContact.vue'
import Vacancy from './Vacancy.vue'
export default {
  name: 'Block',
  components: {
    CompanyForm, FoForm, Footer, FosForm, KmtForm,
    KmtStudio, LastNews, LocatorWithoutMap, LocatorWithMap,
    MemberShip, Menu, NewsLetter, News, Search, StartupPhase,
    StudioContact, Vacancy
  },
  props: ["fit20", "admin", "saveBlock", "cancelEditing"],
  data() {
    return {
      blocks: {
        // the key is the model name in the database
        'company_form': CompanyForm,
        'fo_form': FoForm,
        'footer': Footer,
        'fos_form': FosForm,
        'KMT_country': KmtForm,
        'kmt_studio': KmtStudio,
        'last_news': LastNews,
        'locator_without_map': LocatorWithoutMap,
        'locator_with_map': LocatorWithMap,
        'membership': MemberShip,
        'menu': Menu,
        'newsLetter': NewsLetter,
        'news': News,
        'search': Search,
        'startup_phase': StartupPhase,
        'studio_contact': StudioContact,
        'vacancy': Vacancy,
      }
    };
  }
};
</script>

<style>
.edit-studio-container {
  width: 100%;
  overflow: auto;
  padding-bottom: 20px;
}

.edit-studio-container .tab-content {
  padding-top: 15px;
}

.edit-studio-container .tab-content h2 {
  margin-left: 10px;
}

.edit-studio-container .img-container img {
  border-radius: 15px;
  cursor: pointer;
  max-width: 150px;
}

.edit-studio-container .admin-studio-tab-pane {
  display: none;
  padding-bottom: 30px;
}

.edit-studio-container .form-container.active {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: space-around;
}

.edit-studio-container .form-container div {
  width: calc(100% / 2 - 30px);
}

.edit-studio-container .form-container label {
  display: block;
}

.edit-studio-container .studio-users {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.edit-studio-container .users-col {
  width: calc(100%);
}

.edit-studio-container .studio-machines {
  width: 100%;
}

.edit-studio-container .ex-member-container {
  margin-top: 10px;
}

.edit-studio-container .ex-member-flex {
  width: 100% !important;
}

.edit-studio-container .ex-member-item {
  width: 80% !important;
  border: solid 1px var(--fit20-lighter-gray);
  padding: 5px 7px;
  border-radius: 10px;
  margin-bottom: 7px;
}

.edit-studio-container .ex-member-container img {
  margin-bottom: 7px;

}

.edit-studio-container .measure-div {
  position: relative;
}

.edit-studio-container .kg {
  position: absolute;
  right: 60px;
  bottom: 5px;
}
</style>
